<template>
  <div class="intro_sm d-flex justify-content-center">

    <a
        class="form__submit__secondary font-bold d-inline-flex"
        style="margin-right: 2rem;"
        href="https://www.facebook.com/sharer/sharer.php?u=https%3A//kochamylasy.pl/"
    >
      <span>Facebook</span>
    </a>

    <a
        class="form__submit__secondary font-bold d-inline-flex"
        style=""
        href="https://wa.me/?text=Stwórz%20swoją%20dziką%20walentynkę%20i%20wyślij%20bliskiej%20osobie!%20https%3A%2F%2Fkochamylasy.pl"
    >
      <span>Whatsapp</span>
    </a>
  </div>
</template>
<script>
export default {
  name: "ShareLinks",
  data() {
    return {
      title: "Share links",
    };
  },
};
</script>
